"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _gatsbyLink = _interopRequireDefault(require("gatsby-link"));

var styles = function styles(theme) {
  return {
    item: {
      display: 'block',
      paddingTop: 0,
      paddingBottom: 0
    },
    itemLeaf: {
      display: 'flex',
      paddingTop: 0,
      paddingBottom: 0
    },
    button: {
      justifyContent: 'flex-start',
      textTransform: 'none',
      width: '100%',
      borderRadius: '0px',
      paddingTop: '10px',
      paddingBottom: '9px'
    },
    buttonLeaf: {
      justifyContent: 'flex-start',
      textTransform: 'none',
      width: '100%',
      borderRadius: '0px',
      fontWeight: theme.typography.fontWeightRegular,
      '&.depth-0': {
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    active: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: '#eeeeee'
    }
  };
};

var AppDrawerNavItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(AppDrawerNavItem, _React$Component);

  function AppDrawerNavItem() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, AppDrawerNavItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(AppDrawerNavItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      open: _this.props.openImmediately
    };

    _this.handleClick = function () {
      _this.setState(function (state) {
        return {
          open: !state.open
        };
      });
    };

    return _this;
  }

  (0, _createClass2.default)(AppDrawerNavItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // So we only run this logic once.
      if (!this.props.openImmediately) {
        return;
      } // Center the selected item in the list container.


      var activeElement = document.querySelector(".".concat(this.props.classes.active));

      if (activeElement && activeElement.scrollIntoView) {
        activeElement.scrollIntoView({});
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          depth = _this$props.depth,
          href = _this$props.href,
          onClick = _this$props.onClick,
          openImmediately = _this$props.openImmediately,
          activePage = _this$props.activePage,
          title = _this$props.title,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "classes", "depth", "href", "onClick", "openImmediately", "activePage", "title"]);
      var style = {
        paddingLeft: 8 * (3 + 2 * depth ? depth : 0) + 8
      };

      if (href) {
        return _react.default.createElement(_ListItem.default, (0, _extends2.default)({
          className: classes.itemLeaf,
          disableGutters: true
        }, other), _react.default.createElement(_Button.default, {
          component: function component(props) {
            return _react.default.createElement(_gatsbyLink.default, (0, _extends2.default)({
              variant: "button",
              activeClassName: classes.active,
              to: href
            }, props));
          },
          className: (0, _classnames.default)(classes.buttonLeaf, "depth-".concat(depth)),
          disableRipple: true,
          onClick: onClick,
          style: style
        }, title));
      }

      return _react.default.createElement(_ListItem.default, (0, _extends2.default)({
        className: classes.item,
        disableGutters: true
      }, other), _react.default.createElement(_Button.default, {
        classes: {
          root: classes.button,
          label: openImmediately ? 'algolia-lvl0' : ''
        },
        onClick: this.handleClick,
        style: style
      }, title), _react.default.createElement(_Collapse.default, {
        in: this.state.open,
        timeout: "auto",
        unmountOnExit: true
      }, children));
    }
  }]);
  return AppDrawerNavItem;
}(_react.default.Component);

AppDrawerNavItem.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node,
  classes: _propTypes.default.object.isRequired,
  depth: _propTypes.default.number.isRequired,
  href: _propTypes.default.string,
  onClick: _propTypes.default.func,
  openImmediately: _propTypes.default.bool,
  title: _propTypes.default.string.isRequired
} : {};
AppDrawerNavItem.defaultProps = {
  openImmediately: false
};

var _default = (0, _styles.withStyles)(styles)(AppDrawerNavItem);

exports.default = _default;